import * as actionTypes from '../actions'

type Address = {
  address: Array<any>
}

const initialState: Address = {
  address: [],
}

const addressNomenclatureReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_TYPE_ADDRESS: {
      return {
        ...state,
        address: action.payload
      }
    }

    default: {
      return state
    }
  }
}

export default addressNomenclatureReducer
